import { SettingsSubpage } from '../../components/UserSettings/constants';

export const getSettingsPageUrl = (subpage: SettingsSubpage): string => `/settings/${subpage}`;
